import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const SpaceEnvironmentsCreateKeyInfo = () =>
  <Paragraph>
    <Color variant='theme-color-statuschip-text'>
      <strong>An unique access key file (.ini) will be generated</strong>
    </Color>
    <br />
    <Color variant='form-alert-text-color'>
      Creating an environment will generate a unique access key file (.ini) that you'll need to authenticate your agent. Please save it in a secured location.
    </Color>
  </Paragraph>

export default SpaceEnvironmentsCreateKeyInfo
